import ContentCopyRounded from "@mui/icons-material/ContentCopyRounded";
import MailOutlineRoundedIcon from "@mui/icons-material/MailOutlineRounded";
import { Box, IconButton, Typography } from "@mui/material";
import useAPI from "../../../../api/hooks/useAPI";
import useColors from "../../../../api/hooks/useColors";
import CustomToolTip from "../../../../components/CustomTooltip";
import { Toast } from "../../../../components/Toast";
import SvgToIcon from "../../../../icons/SvgToIcon";
import { logos } from "../../../stack/environment/icons/iconExport";
import { IntegrationsMapping } from "../../../stack/integrations/IntegrationsMapping";
const TriageSection = ({ detection }) => {
  const colors = useColors();
  const { trackEvent } = useAPI();

  const formatMailtoLink = (detection) => {
    const subject = encodeURIComponent(
      "Breeze found suspicious activity in " +
        IntegrationsMapping[detection.tool]?.displayName
    );
    const body =
      "Suspicious activity in " +
      IntegrationsMapping[detection.tool]?.displayName +
      " : " +
      detection.description +
      "\n\n";
    const evidence = "Evidence:\n" + JSON.stringify(detection.evidence);
    const encodedBody = encodeURIComponent(body + evidence);
    return `mailto:?subject=${subject}&body=${encodedBody}`;
  };

  const mailtoLink = formatMailtoLink(detection);

  const handleEmailClick = () => {
    trackEvent(
      `User Clicked on send email button in Triage Section of Detection ${detection.detection_id}`
    );
  };

  const copyDetectionDetails = () => {
    const text = `Breeze found suspicious activity in ${
      IntegrationsMapping[detection.tool]?.displayName
    }.\n Suspicious activity in ${
      IntegrationsMapping[detection.tool]?.displayName
    } : ${detection.description}\n\nEvidence:\n${JSON.stringify(
      detection.evidence
    )}`;
    navigator.clipboard.writeText(text);
    Toast.success(`Copied detection details`);
    trackEvent(
      `User Copied Detection Details in Triage Section of Detection ${detection.detection_id}`
    );
  };

  const buttonStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: colors.text_primary,
    border: "1px solid" + colors.grey_light,
    height: "32px",
    width: "32px",
    textTransform: "none",
    borderRadius: "8px",
    gap: "8px",
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        justifyContent: "center",
      }}
    >
      <Typography variant="overline">Triage</Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <CustomToolTip title="Send an email">
          <IconButton
            component="a"
            href={mailtoLink}
            sx={{
              ...buttonStyle,
            }}
            onClick={handleEmailClick}
          >
            <MailOutlineRoundedIcon sx={{ width: "18px" }} />
          </IconButton>
        </CustomToolTip>
        <CustomToolTip title="Copy the detection details">
          <IconButton
            sx={{
              ...buttonStyle,
            }}
            onClick={copyDetectionDetails}
          >
            <ContentCopyRounded
              sx={{
                width: "18px",
              }}
            />
          </IconButton>
        </CustomToolTip>
        <CustomToolTip title="Send Slack message">
          <IconButton
            sx={{
              ...buttonStyle,
            }}
          >
            <SvgToIcon
              IconLogo={logos.SlackLogo}
              style={{
                width: "18px",
              }}
            />
          </IconButton>
        </CustomToolTip>
        <CustomToolTip title="Open Jira issue">
          <IconButton
            sx={{
              ...buttonStyle,
            }}
          >
            <SvgToIcon
              IconLogo={logos.JiraLogo}
              style={{
                width: "18px",
              }}
            />
          </IconButton>
        </CustomToolTip>
      </Box>
    </Box>
  );
};

export default TriageSection;
